export type Lab = {
    Id: number,
    SytelineAccountNumber: string,
    FacilityName: string,
    AddressLine1: string,
    AddressLine2: string,
    City: string,
    State: string,
    Country: string, 
    PostalCode: string,
    LabPhoneNumber: string,
    LabPhoneNumberExtension: string,
    PrimaryContactName: string,
    SendNotificationsTo: string,
}

export function apiModelToLab(apiModel : any) {
    return {
        Id: apiModel.id,
        SytelineAccountNumber: apiModel.sytelineAccountNumber ? apiModel.sytelineAccountNumber : undefined,
        FacilityName: apiModel.facilityName,
        AddressLine1: apiModel.addressLine1,
        AddressLine2: apiModel.addressLine2,
        City: apiModel.city,
        State: apiModel.state,
        Country: apiModel.country, 
        PostalCode: apiModel.postalCode,
        PrimaryContactName: apiModel.primaryContactName,
        LabPhoneNumber: apiModel.labPhoneNumber,
        LabPhoneNumberExtension: apiModel.labPhoneNumberExtension,
        SendNotificationsTo: apiModel.sendNotificationsTo,
    } as Lab;
}

export const blankLab = {
    Id: 0,
    SytelineAccountNumber: "",
    FacilityName: "",
    AddressLine1: "",
    AddressLine2: "",
    City: "",
    State: "",
    Country: "United States of America", 
    PostalCode: "",
    PrimaryContactName: "",
    LabPhoneNumber: "___-___-____",
    LabPhoneNumberExtension: "",
    SendNotificationsTo: "",
} as Lab;